export default {
  setErrorDetails(state, payload) {
    state.errorDetails = payload
  }
}
